module.exports = __webpack_public_path__ + "img/cakefiveyear.b2e24fbc.png";